import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDirectIncomeBalanceLedger,
  fetchDirectIncomeAccountsBySearch,
} from "./DirectIncomeBalanceLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  directAccounts: [],
  directAccountLoading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const directIncomeBalanceLedgerSlice = createSlice({
  name: "directIncomeBalanceLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDirectIncomeBalanceLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDirectIncomeBalanceLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchDirectIncomeBalanceLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchDirectIncomeAccountsBySearch.pending, (state) => {
        state.directAccountLoading = true;
      })
      .addCase(fetchDirectIncomeAccountsBySearch.fulfilled, (state, action) => {
        state.directAccountLoading = false;
        state.directAccounts = action.payload;
      })
      .addCase(fetchDirectIncomeAccountsBySearch.rejected, (state) => {
        state.directAccountLoading = false;
        state.directAccounts = [];
      });
  },
});

export const { setFilters } = directIncomeBalanceLedgerSlice.actions;
export default directIncomeBalanceLedgerSlice.reducer;
